<template>
  <div class="content">
    <div class="row">
      <div class="col-md-6">
        <h4 class="card-title text-left">카테고리</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-select class="select-primary" @change="getFaqs(1)" size="large" placeholder="카테고리선택" v-model="categoryId">
              <el-option v-for="option in categories" class="select-primary" :value="option.id" :label="option.category" :key="option.category"></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <base-button @click="goForm" type="success">등록</base-button>

    <div class="row">
      <el-table :data="data" @row-click="rowClicked">
        <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
      </el-table>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import { URLUtils } from "@/util/URLUtils";
import { BasePagination } from "@/components/index";
import { formatDateTime } from "@/util/DateUtils";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
  },
  async created() {
    await this.getCategories();
    await this.getFaqs();
  },
  data() {
    return {
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
        },
        {
          prop: "category",
          label: "카테고리",
          minWidth: 50,
        },
        {
          prop: "subject",
          label: "말머리",
          minWidth: 50,
        },
        {
          prop: "title",
          label: "제목",
          minWidth: 150,
        },
        {
          prop: "isVisible",
          label: "노출여부",
          minWidth: 50,
        },
        {
          prop: "regTime",
          label: "작성일",
          minWidth: 50,
        },
      ],
      data: [],
      categoryId: null,
      categories: [{ id: null, category: "전체" }],
      currentPage: 1,
      totalPages: null,
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.getFaqs(this.currentPage);
      },
    },
  },
  methods: {
    async getCategories() {
      return this.$axios.get(`/faq/categories`, null).then((res) => {
        this.categories = this.categories.concat(res.data.data);
      });
    },
    async getFaqs(page) {
      const params = {};
      params.currentPage = page ? page : 1;
      if (this.categoryId) {
        params.categoryId = this.categoryId;
      }
      return this.$axios.get("/faq", { params }).then((res) => {
        this.data = res.data.data.data;
        this.data = this.data.map((item) => {
          item.isVisible = item.isVisible === 1 ? "노출" : "비노출";
          item.regTime = formatDateTime(item.regTime);
          return item;
        });
        this.totalPages = Number(res.data.data.page);
      });
    },
    rowClicked(row) {
      this.$router.push(`/faqs/faqDetail?${URLUtils.objectToQueryString({ id: row.id })}`);
    },
    goForm() {
      this.$router.push(`/faqs/faqDetail`);
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
